import { mutate } from 'swr'
import { nextAPI } from '../apis/Axios'
import { CustomerAPI } from '../apis/CustomerAPI'
import { UserStore } from '../state/UserStore'
import Router from 'next/router'
import _jwt from 'jsonwebtoken'
import { getErrorMessage } from './utils'
import { deleteCookie } from 'cookies-next'
import { impersonateSessionKeyName, impersonatedByEmailKeyName } from './api'

const JWTKEY = process.env.JWTKEY

export const logout = async (redirect = true, redirectURL = null) => {
    const logoutFromStore = UserStore.getState().logout
    await nextAPI.post('/logout')
    deleteCookie(impersonateSessionKeyName)
    deleteCookie(impersonatedByEmailKeyName)
    await logoutFromStore()
    mutate(CustomerAPI.getCustomer, null, false)

    if (redirectURL) Router.push(redirectURL)
    else if (redirect) Router.push('/login')
}

export const loginAsCustomer = async (id) => {
    try {
        const { data: user } = await nextAPI.post('/shop-as-customer/', {
            customer_id: id,
        })
        return user
    } catch (e) {
        const message = getErrorMessage(e)
        throw new Error(message)
    }
}

export const logoutAsCustomer = async (id) => {
    try {
        const { data: user } = await nextAPI.delete('/shop-as-customer/', {
            customer_id: id,
        })
        deleteCookie(impersonateSessionKeyName)
        deleteCookie(impersonatedByEmailKeyName)
        return user
    } catch (e) {
        const message = getErrorMessage(e)
        throw new Error(message)
    }
}

export const generateJWT = (wooCustomer) => {
    const { email, id, username } = wooCustomer
    const site = 'https://admin.openlettermarketing.com'
    return _jwt.sign({ email, id, site, username }, JWTKEY, {
        algorithm: 'HS256',
    }) // HS256
}
